const initialState = []

const menulist = (state = initialState, action) => {
  switch (action.type) {
    case 'menulist':
      return action.payload

    default:
      return state
  }
}
export default menulist
